/**  subject actions constants */
export const SET_LIST_SUBJECT = 'subject/SET_LIST_SUBJECT';